import { useTranslation } from 'react-i18next';
import CustomDataGridResult from '../../../../../../utils/Datagrid/CustomForecastDataGridResult';
import { customDataGridResultSimulation } from '../../../../../../utils/Datagrid/CustomForecastDataGridUtils';

const DataGridCAPHelp = ({ rows }) => {
  const { t } = useTranslation();

  const columns = [
    {
      field: 'fourPoints',
      headerName: t('simulation.result.pac.fourPoints'),
      sortable: false,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
    },
    {
      field: 'fivePoints',
      headerName: t('simulation.result.pac.fivePoints'),
      sortable: false,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
    },
  ];

  const processedRows = [
    {
      id: 'capHelp-row',
      fourPoints: rows[0],
      fivePoints: rows[1],
    },
  ];

  const getRowClassName = () => 'Mui-even';

  return (
    <div className="cap-points-help-container">
      <h3>{t('simulation.result.pac.helpTitle')}</h3>
      <CustomDataGridResult
        rows={processedRows}
        columns={columns}
        isLoading={false}
        theme={customDataGridResultSimulation}
        getRowClassName={getRowClassName}
        simulationContext={'simulation-box'}
        fullSize={true}
      />
      <section className="notes">
        <em>{t('simulation.result.pac.note')}</em>
      </section>
    </div>
  );
};

export default DataGridCAPHelp;
